module.exports = __webpack_public_path__ + "static/media/cancel-white.99867449.svg";